import styled from 'styled-components'
import { Description as BaseDescription } from '../ErrorStep/styled'

export const Description = styled(BaseDescription)`
  color: #fff;
`
